import { render, staticRenderFns } from "./UserAccounts.vue?vue&type=template&id=d5c9b11c&scoped=true&"
import script from "./UserAccounts.vue?vue&type=script&lang=js&"
export * from "./UserAccounts.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/forms/theme-checkbox-radio.css?vue&type=style&index=0&id=d5c9b11c&scoped=true&lang=css&"
import style1 from "@/assets/css/apps/contacts.css?vue&type=style&index=1&id=d5c9b11c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Volumes/Work/Work/gerocare/CrmWeb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c9b11c",
  null
  
)

export default component.exports